{
    "NAME": "ApparaattypenTaal",
    "DeviceTypesLanguage_Unknown": "Onbekend",
    "DeviceTypesLanguage_Trunk": "Kofferbak",
    "DeviceTypesLanguage_TrunkGateway": "Trunk Gateway",
    "DeviceTypesLanguage_ChatService": "Chatservice",
    "DeviceTypesLanguage_EmailServer": "E-mailserver",
    "DeviceTypesLanguage_ExtensionOrEndpoint": "Uitbreiding \/ Eindpunt",
    "DeviceTypesLanguage_ExtensionOrEndpointTrunking": "Uitbreiding (Trunking)",
    "DeviceTypesLanguage_ExtensionOrEndpointHospitality": "Uitbreiding (Gastvrijheid)",
    "DeviceTypesLanguage_GroupSuper": "Supergroep",
    "DeviceTypesLanguage_GroupCollective": "Groep (Collectief)",
    "DeviceTypesLanguage_GroupLinear": "Groep (lineair)",
    "DeviceTypesLanguage_GroupCyclic": "Groep (Cyclisch)",
    "DeviceTypesLanguage_GroupAcd": "Groep (ACD)",
    "DeviceTypesLanguage_GroupTrunk": "Groep (Kern)",
    "DeviceTypesLanguage_GroupVoicemail": "Groep (Voicemail)",
    "DeviceTypesLanguage_GroupPage": "Groep (Pagina)",
    "DeviceTypesLanguage_GroupDepartment": "Afdeling",
    "DeviceTypesLanguage_GroupSecurityGroup": "Beveiligingsgroep",
    "DeviceTypesLanguage_GroupSecurityGroupBroadworks": "Groepen dienstverleners",
    "DeviceTypesLanguage_GroupAcdMsTeams": "Oproepwachtrijen",
    "DeviceTypesLanguage_Park": "Park",
    "DeviceTypesLanguage_VoicemailApplication": "Voicemail-applicatie",
    "DeviceTypesLanguage_VoicemailAnnouncementHuntGroup": "Wachtrijaankondiging (Hunt Group)",
    "DeviceTypesLanguage_VoicemailAnnouncementGeneral": "Wachtrijmededeling (algemeen)",
    "DeviceTypesLanguage_AutoAttendant": "Automatische beantwoorder",
    "DeviceTypesLanguage_MusicOnHold": "Muziek in de wachtstand",
    "DeviceTypesLanguage_Conference": "Conferentie",
    "DeviceTypesLanguage_PilotNumber": "Pilot \/ Alternatief",
    "DeviceTypesLanguage_DnisEntry": "DNS-invoer"
}